import { Routes } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';

import { permissions } from '../../permissions';
import { AuthGuardService as AuthGuard } from '../../auth-guard.service';
import { WhatsNewComponent } from './whatsnew/whatsnew.component';
import { WhatsNewFormComponent } from './whatsnew/whatsnew/whatsnew-form.component';

export const routes: Routes = [
  {
    path: 'whatsnew/list',
    component: WhatsNewComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'New',
      permissions: {
        only: [permissions.COMPARATIO_EMP],
      },
    },
  },
  {
    path: 'whatsnew/add',
    component: WhatsNewFormComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Add',
      permissions: {
        only: [permissions.COMPARATIO_EMP],
      },
    },
  },
  {
    path: 'whatsnew/edit/:id',
    component: WhatsNewFormComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Edit',
      permissions: {
        only: [permissions.COMPARATIO_EMP],
      },
    },
  },
];



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/whatsnew/whatsnew.routing.ts